export const BuildInfo = {timestamp:1775059711000}
